
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Supplier } from "@/types/supplier";

export const useSuppliers = () => {
  const queryClient = useQueryClient();

  const { data = [], isLoading, error, refetch } = useQuery<Supplier[]>({
    queryKey: ["suppliers"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("suppliers")
        .select("*")
        .order("name_ar");
      
      if (error) throw error;
      return data || [];
    },
  });

  return { 
    data, 
    isLoading, 
    error,
    refetch,
    // إضافة الخصائص المطلوبة للتوافق مع الكود الموجود
    filteredSuppliers: data,
    loading: isLoading,
    searchTerm: "",
    setSearchTerm: () => {},
    countryFilter: "",
    setCountryFilter: () => {},
    handleDelete: async (id: string) => {
      try {
        await supabase.from('suppliers').delete().eq('id', id);
        refetch();
      } catch (error) {
        console.error('Error deleting supplier:', error);
      }
    },
    fetchSuppliers: refetch,
    getUniqueCountries: () => []
  };
};

export const useCreateSupplier = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (supplierData: any) => {
      const { data, error } = await supabase
        .from("suppliers")
        .insert([supplierData])
        .select()
        .single();
      
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["suppliers"] });
    },
  });
};

export const useUpdateSupplier = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ id, ...updates }: { id: string; [key: string]: any }) => {
      const { data, error } = await supabase
        .from("suppliers")
        .update(updates)
        .eq("id", id)
        .select()
        .single();
      
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["suppliers"] });
    },
  });
};

export const useDeleteSupplier = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase
        .from("suppliers")
        .delete()
        .eq("id", id);
      
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["suppliers"] });
    },
  });
};
